import React, { useState } from 'react'
import { CensusFileRowStatusEnum } from '../../api/enums/census-file-row-status.enum'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'
import { LoadingOverlay } from '../../components/LoadingOverlay/LoadingOverlay'
import { CensusManagementPageProps } from '../../types/census-management-page-props'
import CategoriseAllButton from '../components/CategoriseSelectedButton'
import CensusReviewCsvExportButton from '../components/CensusReviewCsvExportButton'
import ReviewRecordsBase from '../components/CensusReviewRecordsBase'

const CensusReviewUndetermined = (props: CensusManagementPageProps) => {
  const { importPublicKey } = props.routeParams
  const [pageLoading, setPageLoading] = useState(false)

  return (
    <>
      <LoadingOverlay isLoading={pageLoading} message="Categorising..." />
      <ReviewRecordsBase
        tabKey={CensusFileRowTypeEnum.UNDETERMINED}
        {...props}
        rowQueryParams={{
          censusFileRowStatuses: [CensusFileRowStatusEnum.IN_REVIEW],
          censusRowType: CensusFileRowTypeEnum.UNDETERMINED,
        }}
        actionButton={({ censusRows, handleSubmit }) => (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <CategoriseAllButton
              publicKey={importPublicKey}
              censusRows={censusRows}
              handleSubmit={handleSubmit}
              setPageLoading={setPageLoading}
            />
            <CensusReviewCsvExportButton
              publicKey={importPublicKey}
              exportType={CensusFileRowTypeEnum.UNDETERMINED}
            />
          </div>
        )}
      />
    </>
  )
}

export default CensusReviewUndetermined
